import React from 'react'

const MprolabSmall: React.FC = () => {
  return (
    <svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Full_Default 1" clipPath="url(#clip0_522_21279)">
        <g id="Layer 1">
          <g id="Group">
            <path
              id="Vector"
              d="M33.2644 7.17473V15.8098L27.289 21.9134H18.8352L10.2947 13.1858L11.9356 11.5096L19.7972 19.5475H26.3346L30.9557 14.8273V8.1496L24.0335 1.08661H27.3041L33.2606 7.17473H33.2644ZM14.448 1.08661H5.96028L0 7.17473V15.8098L5.97537 21.9134H9.24598L2.31244 14.8273V8.1496L6.93354 3.42938H13.471L21.3438 11.4711L22.981 9.79879L14.448 1.08661ZM20.9251 1.08661H17.7073L26.478 10.0454V12.9353L24.4786 14.9775H21.6494L12.5619 5.67967H7.85022L4.51925 9.08209V13.8948L12.3657 21.9095H15.5835L6.79396 12.9315V10.0415L8.7933 7.99932H11.6225L20.7101 17.2972H25.4217L28.7527 13.8948V9.08209L20.9251 1.08661Z"
              fill="url(#paint0_linear_522_21279)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_522_21279"
          x1="2.77266"
          y1="20.3413"
          x2="30.8228"
          y2="3.18224"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF029A" />
          <stop offset="0.12" stopColor="#E310B3" />
          <stop offset="0.49" stopColor="#9239FF" />
          <stop offset="0.56" stopColor="#7E53FF" />
          <stop offset="0.77" stopColor="#3CA9FF" />
          <stop offset="0.93" stopColor="#12DFFF" />
          <stop offset="1" stopColor="#03F5FF" />
        </linearGradient>
        <clipPath id="clip0_522_21279">
          <rect width="33" height="23" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MprolabSmall
